import React from 'react';
import { Classes } from '../index';

export const AppLayoutTestWrapper: React.FC = ({ children }) => {
  return (
    <div className={Classes.APP_LAYOUT_TEST_WRAPPER}>
      <div className={Classes.APP_LAYOUT_TEST_WRAPPER_BODY}>{children}</div>
    </div>
  );
};
